import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges  } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router, UrlSegment } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { MapService } from 'src/app/services/map.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';
interface Cervezas{
  value: number;
  name: string;
}
interface TanqueDisponible {
  deviceId: number;
  slots: number[];
}
interface Clientes{
  value: number;
  name: string;
}
interface Dispositivos{
  deviceId: number;
  estalbishmentId: number;
  dev_label: string;
  dev_reference: string;
}
@Component({
  selector: 'app-ver-tanque',
  templateUrl: './ver-tanque.component.html',
  styleUrls: ['./ver-tanque.component.css']
})
export class VerTanqueComponent {
  lat: number = 43.0081016;
  lng: number = -7.5561412;
  zoom: number = 14;
  addressData: any;

  identificadorCliente: string = "";
  nTanque: string = "";
  dispositivoCreado: boolean = false;
  errorMessage : string =""; //Mensaje de error
  errorFinal: boolean = false;
  waitAfterSave: boolean = false;
  cervezas: Cervezas[] = []
  tanqueId: any;

  //ERROR
  campoObligatorioError: boolean = false;
  dispositivoError: boolean = false;
  cervezaError: boolean = false;
  capacidadError: boolean = false;
  numeroTanqueError: boolean = false;
  customNumeroTanqueError: boolean = false;

  //DATA
  establishmentsData: any;
  devicesData: any;
  tanqueActualData: any;
  dispositivoActualData: any;

  //DISPOSITIVOS
  dispositivos: Dispositivos[] = [
  ];
  selectedDevice: number | undefined;

  //CLIENTES
  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  //TANQUES DISPONIBLES
  numeroTanqueDisponibles: TanqueDisponible[] = [];
  slotsDisponibles: number[] = [];
  tanqueSeleccionado: number | undefined;
  mostrarHint = true;

  //CAPACIDAD TANQUE
  capacidadFormGroup: FormGroup = new FormGroup({
    capacidadTanque: new FormControl('',[Validators.pattern(/^\d+(,\d+)?$/)])
  });

  //POSICION CUSTOM
  customPositionFormGroup: FormGroup = new FormGroup({
    customPosition: new FormControl('', [Validators.pattern(/^\d+$/)])
  });

  //CERVEZA SELECCIONADA
  cervezasControl: FormControl = new FormControl();

  //CONFIGURACIÓN DE ALARMAS
  configuracionAlarmas: FormGroup = new FormGroup({
    nivelCerveza: new FormControl('', [
      Validators.min(0),
      Validators.max(100),
      (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
          return null;
        }
        //Tenemos que substituir la coma por el punto para que realice bien la comprobación
        const sanitizedValue = value.replace(',', '.');
        if (!/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/.test(sanitizedValue)) {
          return { pattern: true };
        }
        const numericValue = parseFloat(sanitizedValue);
        if (isNaN(numericValue)) {
          return { pattern: true };
        }
    
        if (numericValue < 0) {
          return { min: true };
        }
        if (numericValue > 100) {
          return { max: true };
        }
        return null;
      },
    ]),
    temperaturaTanqueMin: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
    temperaturaTanqueMax: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
    presionMax: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
    presionMin: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
  });

  errorCamposIncorrectos: boolean = false;
  selectedDispositivo: any;
  userData: any = [];
  nombreDispositivo: string = "";
  map: any; 
  marker: any;
  establecimientoNombre: string = "";

  //Subscripciones
  private establishmentsSubscription: Subscription | undefined;
  private devicesSubscription: Subscription | undefined;
  private beerTypesSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;
  private editarTanqueSubscription: Subscription | undefined;

  @Input() userId: any;

  constructor(private userDataService: UserDataService ,private deviceService: DeviceService, private mapService: MapService,
    private error429: Error429Service, private formBuilder: FormBuilder, private userService : UserService, private router: Router,
    private cdr: ChangeDetectorRef){
      this.userData = this.userDataService.getUserData();
      this.tanqueId = this.getTanqueIdFromCurrentPath(router);
    }

  ngOnInit(): void {
    //Mapa
    //this.getAddress(this.lat, this.lng);
    //Datos de los establecimientos
    this.devicesSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next:resp =>{
        this.devicesData = resp.filter((device:any) => !device.locked);
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () =>{
        this.establishmentsSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
          next:resp =>{
            this.establishmentsData = resp;
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete: () =>{
            //CREAR LISTA CON LOS SLOTS OCUPADOS
            for (let i = 0; i < this.devicesData.length; i++) {
              const tanquesDisponibles: TanqueDisponible = {
                deviceId: this.devicesData[i].id,
                slots: []
              };
            
              if (this.devicesData[i].tanks.length !== 0) {
                for (let j = 0; j < this.devicesData[i].tanks.length; j++) {
                  if (this.devicesData[i].tanks[j].slot) {
                    tanquesDisponibles.slots.push(this.devicesData[i].tanks[j].slot);
                  }
                }
              }
            
              // Incluso si no hay slots ocupados, agregamos el objeto tanquesDisponibles a la lista
              this.numeroTanqueDisponibles.push(tanquesDisponibles);
            }

            //INFORMACIÓN DEL TANQUE ACTUAL
            for(let i=0; i<this.devicesData.length; i++){
              for(let j=0; j<this.devicesData[i].tanks.length; j++){
                if(this.devicesData[i].tanks[j].id == this.tanqueId){
                  this.tanqueActualData = this.devicesData[i].tanks[j];
                }
              }
            }
            for(let i=0; i<this.devicesData.length; i++){
              if(this.devicesData[i].id == this.tanqueActualData.device_id){
                this.dispositivoActualData = this.devicesData[i];
              }
            }
            this.cambiarNombreEstablecimiento(this.dispositivoActualData.id);
            this.identificadorCliente = this.tanqueActualData.external_id;
            this.customPositionFormGroup.setValue({
              customPosition: this.tanqueActualData.custom_num,
            });
            this.capacidadFormGroup.setValue({
              capacidadTanque: this.soloDosDecimalesConComa(this.tanqueActualData.capacity),
            });
            this.cervezasControl.setValue(this.tanqueActualData.beer_type_id);
            let alarmRanges = JSON.parse(this.tanqueActualData.alarm_ranges);
            //console.log(this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMin));
            this.configuracionAlarmas.setValue({
              nivelCerveza: this.soloDosDecimalesConComa(alarmRanges.beerLevelMin), 
              //alarmRanges?.beerLevelMin != null ? alarmRanges.beerLevelMin.toString().replace('.', ',') : null,
              temperaturaTanqueMin: this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMin),
              temperaturaTanqueMax: this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMax),
              presionMin: this.soloDosDecimalesConComa(alarmRanges.beerPressureMin),
              presionMax: this.soloDosDecimalesConComa(alarmRanges.beerPressureMax),
            });
            //Conseguir el dispositivo seleccionado, las coordenadas y la dirección
            this.selectedDispositivo = this.dispositivoActualData;
            //Conseguir nombre del dispositivo
            let nombre = "";
            let referencia = "";
            nombre = this.devicesData.find((dispositivo:any) => dispositivo.id === this.selectedDispositivo.id)?.dev_label;
            referencia = this.devicesData.find((dispositivo:any) => dispositivo.id === this.selectedDispositivo.id)?.dev_reference;
            this.nombreDispositivo = nombre +' ( '+ referencia +' )';
            const coordenadas = this.obtenerCoordenadasEstablecimiento(this.selectedDispositivo.dev_est_id);
            this.lat = coordenadas.est_lat;
            this.lng = coordenadas.est_lng;
            const deviceId = this.selectedDispositivo.id;
            const dispositivoEncontrado = this.numeroTanqueDisponibles.find(dispositivo => dispositivo.deviceId === deviceId);
            if (dispositivoEncontrado) {
              const slotsOcupados = dispositivoEncontrado.slots;
                // Quitar this.tanqueActualData.slot de la lista de slots ocupados
              const indexToRemove = slotsOcupados.indexOf(this.tanqueActualData.slot);
              if (indexToRemove !== -1) {
                slotsOcupados.splice(indexToRemove, 1);
              }
              // Generar la lista de slots disponibles restando los ocupados del conjunto completo de slots
              const todosLosSlots = [1, 2, 3, 4]; // 4 slots disponibles por el momento
              this.slotsDisponibles = todosLosSlots.filter(slot => !slotsOcupados.includes(slot));
              //console.log('Slots disponibles:', this.slotsDisponibles);
            } else {
              //console.error('Dispositivo no encontrado en numeroTanqueDisponibles');
            }
            /*************************************************************/
            this.tanqueSeleccionado = this.tanqueActualData.slot;
            this.selectedCliente = this.tanqueActualData.cliente_id
            this.mapService.loadMapScript(this.initMap.bind(this));
          }
        });

/*      tanqueData.append('_method', "PUT");
        tanqueData.append('device_id', this.selectedDispositivo.deviceId);
        tanqueData.append('beer_type_id', this.cervezasControl?.value);
        tanqueData.append('external_id', this.identificadorCliente);
        tanqueData.append('capacity', this.capacidadTanqueInput?.value);
        tanqueData.append('slot', this.tanqueSeleccionado?.toString() || '');
        tanqueData.append('custom_num', this.customPositionInput?.value);
        tanqueData.append('alarm_ranges', jsonData);
        tanqueData.append('cliente_id', this.selectedCliente?.toString() || ''); */
      }
    });
    //Tipos de cerveza
    this.cervezasControl = this.formBuilder.control([]);
    this.beerTypesSubscription = this.deviceService.getBeerType().subscribe({
      next:resp =>{
        this.cervezas = resp.map((item: any) => ({ value: item.id, name: item.name }));
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }
    });
    //Clientes
    if(this.userData.pro_id == 4){
      this.clientsSubscription = this.userService.getClients().subscribe({
        next:resp =>{
          for(let i=0; i<resp.length; i++){
            this.clientes.push({
              value: resp[i].id,
              name: resp[i].razon_social
            });
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () =>{}
      })
    }
  }

  cambiarNombreEstablecimiento(deviceId: number){
    const device = this.devicesData.find((device:any)=> device.id == deviceId);
    this.establecimientoNombre = device.establishment.est_name;
  }

  soloDosDecimalesConComa(numero: number | undefined){
    if(Number.isNaN(numero)){
      return null;
    } else {
      if(numero == undefined){
        return null;
      } else {
        return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
      }
    }
  }

  devolverNombreCerveza(){
    return this.cervezas.find(cerveza => cerveza.value === this.cervezasControl.value)?.name;
  }

  devolverCliente(){
    return this.clientes.find(cliente => cliente.value === this.selectedCliente)?.name;
  }

  getTanqueIdFromCurrentPath(router: Router): number {
    const urlTree = router.parseUrl(router.url);
    const segments: UrlSegment[] = urlTree.root.children['primary'].segments;
    // Buscamos el segmento que contiene el número
    let deviceId: number | null = null;
    for (const segment of segments) {
      const value = parseInt(segment.path, 10);
      if (!isNaN(value)) {
        deviceId = value;
        break;
      }
    }
    return deviceId || 0;
  }

  get capacidadTanqueInput() { 
    return this.capacidadFormGroup.get('capacidadTanque'); 
  }
  get customPositionInput() { 
    return this.customPositionFormGroup.get('customPosition'); 
  }
  get nivelCervezaInput() { 
    return this.configuracionAlarmas.get('nivelCerveza'); 
  }
  get temperaturaTanqueMinInput() { 
    return this.configuracionAlarmas.get('temperaturaTanqueMin'); 
  }
  get temperaturaTanqueMaxInput() { 
    return this.configuracionAlarmas.get('temperaturaTanqueMax'); 
  }
  get presionMinInput() { 
    return this.configuracionAlarmas.get('presionMin'); 
  }
  get presionMaxInput() { 
    return this.configuracionAlarmas.get('presionMax'); 
  }

  ngOnDestroy(): void {
    if (this.establishmentsSubscription) {
      this.establishmentsSubscription.unsubscribe();
    } 
    if (this.beerTypesSubscription) {
      this.beerTypesSubscription.unsubscribe();
    } 
    if (this.devicesSubscription) {
      this.devicesSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.editarTanqueSubscription) {
      this.editarTanqueSubscription.unsubscribe();
    } 
  }

  getAddress(latitude: number, longitude: number) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: {lat: latitude, lng: longitude} }).then((response) => {
      //la posicion 0 es el lugar más cercano al click
      console.log(response);
      if(response.results[0]) {
        this.addressData = response.results[0].formatted_address;
        console.log(this.addressData);
        this.cdr.detectChanges();
      } else{
        this.addressData = "No encontrado"
        //window.alert("No hay resultados");
      }
    });
  }

  updateEstadoDispositivo() {
    if (this.selectedDispositivo == undefined) {
        this.campoObligatorioError = true;
        this.mostrarHint = true;
    } else {
        console.log(this.selectedDispositivo);
        this.campoObligatorioError = false;
        this.mostrarHint = false;
        //COORDENADAS ESTABLECIMIENTO
        const coordenadas = this.obtenerCoordenadasEstablecimiento(this.selectedDispositivo.dev_est_id);
        this.lat = coordenadas.est_lat;
        this.lng = coordenadas.est_lng;
        this.getAddress(this.lat, this.lng);
        //SLOTS DISPONIBLES EN EL DISPOSITIVO
        const deviceId = this.selectedDispositivo.id;

        // Buscar el dispositivo en numeroTanqueDisponibles
        const dispositivoEncontrado = this.numeroTanqueDisponibles.find(dispositivo => dispositivo.deviceId === deviceId);
    
        if (dispositivoEncontrado) {
          // Obtener los slots ocupados en el dispositivo
          const slotsOcupados = dispositivoEncontrado.slots;
    
          // Generar la lista de slots disponibles restando los ocupados del conjunto completo de slots
          const todosLosSlots = [1, 2, 3, 4]; // 4 slots disponibles por el momento
          this.slotsDisponibles = todosLosSlots.filter(slot => !slotsOcupados.includes(slot));
    
          console.log('Slots disponibles:', this.slotsDisponibles);
        } else {
          console.error('Dispositivo no encontrado en numeroTanqueDisponibles');
        }
    }
  }

  async initMap(): Promise<void>{
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      this.map = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: this.map,
        draggable: false,
        title: 'Marcador'
      });
      this.getAddress(this.lat, this.lng);
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
  }

  obtenerCoordenadasEstablecimiento(id: number) {
    const establishment = this.establishmentsData.find((establishment:any) => establishment && establishment.id === id);
    if(establishment){
      return {
        est_lat: establishment.est_lat,
        est_lng: establishment.est_lng
      }
    } else {
      return {
        est_lat: null,
        est_lng: null
      }
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  guardarDispositivo() {

    const alarmas = {
      nivelCerveza: this.nivelCervezaInput?.value,
      temperaturaTanqueMin: this.temperaturaTanqueMinInput?.value,
      temperaturaTanqueMax: this.temperaturaTanqueMaxInput?.value,
      presionMin: this.presionMinInput?.value,
      presionMax: this.presionMaxInput?.value
    };
    const jsonData = JSON.stringify(alarmas);

    console.log('Identificador del cliente:', this.identificadorCliente);
    console.log('Numero de tanque personalizado:', this.customPositionInput?.value);
    console.log('Numero de tanque:', this.tanqueSeleccionado);
    console.log('Capacidad de tanque:', this.capacidadTanqueInput?.value);
    console.log('Cerveza seleccionada: ', this.cervezasControl.value);

    console.log('Nivel mínimo de cerveza(%): ',this.nivelCervezaInput?.value);
    console.log('Temperatura mínima tanque: ',this.temperaturaTanqueMinInput?.value);
    console.log('Temperatura máxima tanque: ',this.temperaturaTanqueMaxInput?.value);
    console.log('Presion mínima: ',this.presionMinInput?.value);
    console.log('Presion máxima: ',this.presionMaxInput?.value);
    console.log('Alarmas json: ', jsonData);

    console.log('Dispositivo seleccionado: ',this.selectedDispositivo);
    console.log('Cliente seleccionado: ', this.selectedCliente);

    console.log("--------------------------------");
  }
}
